import $ from 'jquery';

export default () => {
  $('.custom-tabs').on('click', '.custom-tabs--nav-item', function(e) {
    e.stopPropagation();

    const $this = $(this);
    const $parent = $this.closest('.custom-tabs');

    // Set active tab.
    if ($parent.length > 0) {
      const target = $this.data('target');

      if (target) {
        $('.custom-tabs--item', $parent).removeClass('active');
        $(`#${target}`, $parent).addClass('active');

        // Set active nav item.
        const $parentNav = $this.closest('.custom-tabs--nav');

        if ($parentNav.length > 0) {
          $('.custom-tabs--nav-item', $parentNav).removeClass('active');
        }

        $this.addClass('active');
      }
    }
  });

  $('.tabbed').each(function(index, el) {
    const $mobile_container = $('.mobile', this);
    const $mobile_switches = $('.tab__switch', $mobile_container);
    const $normal_container = $('.normal', this);
    const $normal_switches = $('.tab__switch', $normal_container);
    const $tabs = $('.tab', this);

    $normal_switches.click(function(event) {
      const $switch = $(this);

      event.preventDefault();

      $tabs
        .add($mobile_switches).add($normal_switches)
        .removeClass('active')
        .filter(`[data-tab-id=${ $switch.data('tab-id') }]`)
        .addClass('active');

      $normal_container.addClass('hide');
    });

    $mobile_container.click(function() {
      $normal_container.removeClass('hide');
    });
  });
}
